import { push, ref } from 'firebase/database';
import { Session } from '../../Models/session';
import { database } from '../firebase';

export const addSession: (
    year: number,
    month: number,
    day: number,
    hour: number,
    minute: number,
    capacity: number,
    description: string,
    difficulty: string,
    online: boolean,
    location: string,
    people?: { [personId: string]: boolean },
    special?: boolean,
) => Promise<void> = async (
    year,
    month,
    day,
    hour,
    minute,
    capacity,
    description,
    difficulty,
    online,
    location,
    people = {},
    special = false,
) => {
    const session: Session = {
        year: year,
        month: month,
        day: day,
        hour: hour,
        minute: minute,
        capacity: capacity,
        people: people,
        description: description,
        difficulty: difficulty,
        online: online,
        location: location,
        special: special,
    };

    try {
        await push(ref(database, 'sessions'), session);
    } catch (err) {
        throw Error(`Nelze vytvořit lekci: ${err} `);
    }
};
